import { Component, Prop, Watch } from 'vue-property-decorator';
import { LabelSetting } from '../../i18n/locale-helper';
import Vue from 'vue';
import { filterForTree } from '../../utils/util';

@Component({
    template: require('./template.html')
})
export default class TreePopoverComponent extends Vue {

    @Prop()
    datasource: any[];

    @Prop()
    parentfield: string;

    @Prop()
    keyfield: string;

    @Prop()
    labelfield: string;

    @Prop()
    iconclass: string;

    @Prop()
    maintext: string;

    @Prop()
    values: number[];

    @Prop()
    mainvalue: number;

    @Prop()
    popoveropen: boolean;

    @Prop() title: string;

    @Prop() placeholder: string;

    @Prop()
    niceStyle: boolean;

    private _cloneValues: number[];
    private _cloneChoices: any[];
    private _cloneMain: number;
    private filterTree: string = undefined
    private isShowMain: number = -1
    private isClickOnMain: boolean = false

    $refs: {
        criteriaRef
    }
    get props() {
        return {
            label: 'label',
            children: 'children'
        };
    }

    /**
     *
     */
    constructor() {
        super();
    }

    created() {

    }

    get lblSetting(){
        return LabelSetting.Action;
    }

    get hierarchy(): any[] {
        let _data = JSON.parse(JSON.stringify(this.datasource));
        let h = (_data || []).filter(type => type[this.parentfield] === undefined || type[this.parentfield] === 0)
            .map((type, index) => this.getHierarchyNodes(type, _data));
        return h;
    }

    getHierarchyNodes(obj: any, dataSource1: any): any[] {
        obj['label'] = `${obj[this.labelfield]}`;
        obj['children'] = dataSource1.filter(node => node[this.parentfield] === obj[this.keyfield]).map((node) => this.getHierarchyNodes(node, dataSource1));
        // Get from stack and remove item
        dataSource1 = dataSource1.filter(node => node[this.parentfield] !== obj[this.keyfield]);
        return obj;
    }

    get checkedHierarchy(): any[] {
        let _data = JSON.parse(JSON.stringify(this.datasource));
        let h = [];
        (_data || [])
            .filter(type => type[this.parentfield] === undefined
                || type[this.parentfield] === 0).map((type, index) => this.getCheckedHierarchyNodes(type, _data, h));
        return h;
    }

    getCheckedHierarchyNodes(obj: any, dataSource1: any[], returnItems: any[]): any[] {
        let tree = (this.$refs.criteriaRef as any);
        let keys = tree.getCheckedKeys();
        if (keys.indexOf(obj[this.keyfield]) > -1) {
            returnItems.push(obj);
        }
        else {
            dataSource1
                .filter(node => node[this.parentfield] === obj[this.keyfield]).map((node) => this.getCheckedHierarchyNodes(node, dataSource1, returnItems));
        }

        // Get from stack and remove item
        dataSource1 = dataSource1.filter(node => node[this.parentfield] !== obj[this.keyfield]);
        return obj;
    }

    rendercontent(h, { node, data, store }) {
        const vm = this
        if (node.checked && data[vm.keyfield] === vm.mainvalue) {
            return h('span', 
                [
                    h('i', { domProps: { className: data[vm.iconclass] } }), 
                    h('b', { domProps: {className: 'el-p-right-5'}, style: { 'color': 'red' } }, node.label)
                ]
            );
        }
        if (node.checked && vm.mainvalue !== data[vm.keyfield])
            return h('span', 
                [
                    data[vm.iconclass] ? h('i', { domProps: { className: data[vm.iconclass] } }) : '', 
                    h('span',{domProps:{className: 'el-p-right-5'}}, node.label),
                    (vm.coIsShowMain === data[vm.keyfield]) ? h('span', [h('button',{domProps: {className: 'el-button el-button--mini el-m-right-5 el-button--default is-round'},on:{click: () => vm.handleMainNode()}} , vm.$t(vm.lblSetting.main))]) : ''
                ]
            );
        return h('span', 
            [
                data[vm.iconclass] ? h('i', { domProps: { className: data[vm.iconclass] } }) : '', 
                h('span',{domProps: {className: 'el-p-right-5'}},  node.label)
            ]
        );
    }
    
    rendernicecontent(h, { node, data, store }) {
        const vm = this
        if (node.checked && data[vm.keyfield] === vm.mainvalue) {
            return h('span', { domProps: { className: 'el-row--flex is-justify-space-between is-align-middle', style: 'width: 100%'} },
                [
                    data[vm.iconclass] ? h('i', { domProps: { className: data[vm.iconclass] } }) : '', 
                    h('span',{domProps: {className: 'el-p-right-5'}},  node.label),
                    h('span', [h('button',{domProps: {className: 'el-button el-button--mini el-m-right-5 el-button--default is-round', style: 'border-color: red; color: red'}} , vm.$t(vm.lblSetting.main))])
                ]
            );
        }
        if (node.checked && vm.mainvalue !== data[vm.keyfield])
            return h('span', { domProps: { className: 'el-row--flex is-justify-space-between is-align-middle', style: 'width: 100%'} },
                [
                    data[vm.iconclass] ? h('i', { domProps: { className: data[vm.iconclass] } }) : '', 
                    h('span',{domProps:{className: 'el-p-right-5'}}, node.label),
                    h('span', [h('button',{domProps: {className: 'el-button el-button--mini el-m-right-5 el-button--default is-round', style: 'border-color: #666666; color: #666666'},on:{click: () => vm.handleCurrentMainNode(data)}} , vm.$t(vm.lblSetting.main))])
                ]
            );
        return h('span', { domProps: { className: 'el-row--flex is-justify-space-between is-align-middle', style: 'width: 100%'} },
            [
                data[vm.iconclass] ? h('i', { domProps: { className: data[vm.iconclass] } }) : '', 
                h('span',{domProps: {className: 'el-p-right-5'}},  node.label),
                h('span', [h('button',{domProps: {className: 'el-button el-button--mini el-m-right-5 el-button--default is-disabled is-round', disabled: 'disabled'}} , vm.$t(vm.lblSetting.main))])
            ],
            
        );
    }

    get coTitle () { return this.title }
    get coIsShowMain () { return this.isShowMain }
    set coIsShowMain (value: number) { this.isShowMain = value }

    handleNodeClick(data, node) {
        if (!this.isClickOnMain && this.niceStyle === true) {
            this.handleClickOnNodeLabel(node);
        }
        this.isClickOnMain = false;
        this.coIsShowMain = data[this.keyfield]
    }
    handleMainNode() {
        let vm = this;
        // setTimeout(function () {
        let tree = (vm.$refs.criteriaRef as any);
        let currentNode = tree.getCurrentNode();
        if (currentNode !== null) {
            let checkKeys: number[] = tree.getCheckedKeys();
            if (currentNode.Id === vm.mainvalue) {
                vm.$emit('update:mainvalue', 0);
            }
            else {
                vm.$emit('update:mainvalue', currentNode.Id);
                checkKeys.push(currentNode.Id);
            }
            tree.setCheckedKeys(checkKeys);
        }
        // }, 10);
    }

    handleCurrentMainNode(node) {
        let vm = this;
        let tree = (vm.$refs.criteriaRef as any);
        let currentNode = {...node};

        vm.isClickOnMain = true;
        if (currentNode !== null) {
            let checkKeys: number[] = tree.getCheckedKeys();
            if (currentNode.Id === vm.mainvalue) {
                vm.$emit('update:mainvalue', 0);
            }
            else {
                vm.$emit('update:mainvalue', currentNode.Id);
                checkKeys.push(currentNode.Id);
            }
            tree.setCheckedKeys(checkKeys);
        }
    }

    handleClickOnNodeLabel( node) {
        let vm = this;
        let tree = (vm.$refs.criteriaRef as any);
        if (node) {
            const flag = !(node.checked);
            tree.setChecked(node, flag);
        }
    }

    handleCheckedChange(data, checked, indeterminate) {
        let vm = this;
        if (checked && (vm.mainvalue === 0 || vm.mainvalue === undefined || vm.mainvalue === -1)) {
            vm.$emit('update:mainvalue', data[this.keyfield]);
        }
        else if (!checked && data[this.keyfield] === vm.mainvalue) {
            vm.$emit('update:mainvalue', 0);
        }
    }

    handleOK() {
        let vm = this;
        // setTimeout(function () {
        let tree = (vm.$refs.criteriaRef as any);
        let list = tree.getCheckedKeys();
        /* these handle in closePopover method below ...

        // vm.$emit('update:values', list);
        // vm.$emit('update:checkeditems', vm.checkedHierarchy);
        // vm.$emit('update:mainvalue', vm.mainValue);
        */

        vm.$emit('update:popoveropen', false);
        vm._cloneValues = list === undefined ? [] : list;
        vm._cloneChoices = vm.checkedHierarchy === undefined ? [] : vm.checkedHierarchy;
        vm._cloneMain = vm.mainvalue;
        // }, 10);
    }

    handleCancel() {
        let vm = this;
        vm.$emit('update:popoveropen', false);
    }

    closePopover() {
        let vm = this;
        // setTimeout(function () {
        let tree = (vm.$refs.criteriaRef as any);
        vm.$emit('update:values', vm._cloneValues);
        vm.$emit('update:checkeditems', vm._cloneChoices);
        vm.$emit('update:mainvalue', vm._cloneMain);
        tree.setCheckedKeys(vm._cloneValues);
        // }, 10);
    }

    mounted() {
        this._cloneValues = this.values === undefined ? [] : this.values;
        this._cloneMain = this.mainvalue === undefined ? 0 : this.mainvalue;
        this._cloneChoices = this.checkedHierarchy === undefined ? [] : this.checkedHierarchy;
    }
    get coFilterTree () { return this.filterTree }
    set coFilterTree (value: string) {
        this.$refs.criteriaRef.filter(value)
        this.filterTree = value
    }
    filterNode (value, data) {
        return filterForTree(value, data, this.labelfield)
    }
    @Watch('popoveropen')
    handleOpen(){
        if(this.popoveropen){
            // UPDATE CURRENT SELECTED 
            let vm = this;
            let tree = (vm.$refs.criteriaRef as any);
            tree.setCheckedKeys(this.values);

            this._cloneValues = this.values === undefined ? [] : this.values;
            this._cloneMain = this.mainvalue === undefined ? 0 : this.mainvalue;
            this._cloneChoices = this.checkedHierarchy === undefined ? [] : this.checkedHierarchy;
        }else{
            this.closePopover();
        }
    }

    beforeDestroy(){
        this._cloneValues =  null;
        this._cloneChoices =  null;
        this._cloneMain =  null;
        this.filterTree =  null;
        this.isShowMain =  null;
        this.isClickOnMain = false;
    }

    @Watch('values')
    handleValuesChange(){
        if(!this.values || this.values.length == 0) return;

        let mainItem = this.values.find(c=>c == this.mainvalue)
        if(!mainItem){
            let selectedItems = this.datasource.filter(c=> this.values.indexOf(c.Id)>=0);
            if(selectedItems && selectedItems[0]){
                selectedItems[0].IsMain = true;
                this.$emit('update:mainvalue', this.values[0]);
                this.$emit('update:checkeditems', selectedItems);
            }
        }
            
    }
}